<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-view">

    <vs-popup class="users-list" :title="$t('USER.MigrateRecords')" :active.sync="showMigrateRecordsModal">
  <div class="vx-row">
    <div class="vx-col w-full">
      <label class="vs-input--label">{{$t('USER.SelectUser')}}</label>
      <div @click="onSelectClick">
        <v-select :closeOnSelect="true" :clearable="false" v-model="userToMigrate" label="name" :options="usersList" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
      </div>
      <div id="blank_content" style="height: 1px;" v-show="showBlankContent"></div>
      <vs-button style="float: right!important;" class="ml-auto mt-2" @click="migrateRecords">{{$t('USER.Migrate')}}</vs-button>
    </div>
  </div>
</vs-popup>

<vs-alert color="danger" :title="$t('USER.UserNotFound')" :active.sync="user_not_found">
  <span>{{$t('USER.UserRecordNotFound', {userHash: $route.params.userHash})}}</span>
  <span>
    <span>{{$t('USER.Check')}}</span><router-link :to="{name:'page-user-list'}" class="text-inherit underline">{{$t('USER.AllUsers')}}</router-link>
  </span>
</vs-alert>

<vs-alert color="danger" :title="$t('USER.UserNotFound')" :active.sync="user_not_found">
  <span>{{$t('USER.UserRecordNotFound', {userHash: $route.params.userHash})}}</span>
  <span>
    <span>{{$t('USER.Check')}}</span><router-link :to="{name:'page-user-list'}" class="text-inherit underline">{{$t('USER.AllUsers')}}</router-link>
  </span>
</vs-alert>

    <div id="user-data" v-if="user_data">

      <vx-card :title="$t('USER.UserInfo')" class="mb-base">

        <!-- Avatar -->
        <div class="vx-row">

          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <div v-if="user_data.photo === '/' || !user_data.photo">
                <div id="user_photo" class="con-vs-avatar mr-4 80px" style="width: 80px; height: 80px; background: rgb(195, 195, 195);"><!----><span translate="translate" class="vs-avatar--text notranslate material-icons person material-icons" style="transform: translate(-50%, -50%) scale(1); color: rgb(255, 255, 255);">
                    {{ $t('USER.Person') }}
                  </span></div>

              </div>
            <div v-else>
              <img :src="user_data.photo" class="rounded w-full" />
            </div>
            </div>
          </div>

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">{{ $t('USER.Name') }}</td>
                <td>{{ user_data.name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('USER.Email') }}</td>
                <td>{{ user_data.email }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">{{ $t('USER.Status') }}</td>
                <td>{{ $t(`USER.${user_data.status_name}`) }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('USER.Position') }}</td>
                <td>{{ user_data.role.name }}</td>
              </tr>
              <!-- <tr>
                <td class="font-semibold">Company</td>
                <td>{{ user_data.company }}</td>
              </tr> -->
            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" :to="{name: 'users-edit', params: { userId: $route.params.userHash }}">{{ $t('USER.Edit') }}</vs-button>
            <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" v-show="user_data.hash !== this.$store.state.auth.user.hash" @click="confirmDeleteRecord">{{ $t('USER.Delete') }}</vs-button>
          </div>

        </div>

      </vx-card>

      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card :title="$t('USER.otherInfo')" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">{{ $t('USER.DOB') }}</td>
                <td>{{ user_data.birth_date }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('USER.Phone') }}</td>
                <td>{{ user_data.mobile }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('USER.Website') }}</td>
                <td>{{ user_data.website }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('USER.Languages') }}</td>
                <td>{{ user_data.languages.join(", ") }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Gênero</td>
                <td v-if="user_data.gender_id === 1">{{ $t('USER.male') }}</td>
                <td v-else-if="user_data.gender_id === 2">{{ $t('USER.female') }}</td>
                <td v-else>{{ $t('USER.other') }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t('USER.AcceptsContactBy') }}</td>
                <td>
                  {{ user_data.contacts.join(", ") }}
                </td>
              </tr>
            </table>
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Social Links" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">Twitter</td>
                <td>{{ user_data.twitter }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Facebook</td>
                <td>{{ user_data.facebook }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Instagram</td>
                <td>{{ user_data.instagram }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Blog</td>
                <td>{{ user_data.blog }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Skype</td>
                <td>{{ user_data.skype }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Slack</td>
                <td>{{ user_data.slack }}</td>
              </tr>
            </table>
          </vx-card>
        </div>
      </div>

      <!-- Permissions -->
      <!-- <vx-card>

        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="flex items-end px-3">
              <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
              <span class="font-medium text-lg leading-none">Permissions</span>
            </div>
            <vs-divider />
          </div>
        </div>

        <div class="block overflow-x-auto">
          <table class="w-full permissions-table">
            <tr> -->
              <!--
                You can also use `Object.keys(Object.values(data_local.permissions)[0])` this logic if you consider,
                our data structure. You just have to loop over above variable to get table headers.
                Below we made it simple. So, everyone can understand.
               -->
              <!-- <th class="font-semibold text-base text-left px-3 py-2" v-for="heading in ['Module', 'Read', 'Write', 'Create', 'Delete']" :key="heading">{{ heading }}</th>
            </tr>

            <tr v-for="(val, name) in user_data.permissions" :key="name">
              <td class="px-3 py-2">{{ name }}</td>
              <td v-for="(permission, name) in val" class="px-3 py-2" :key="name+permission">
                <vs-checkbox v-model="val[name]" class="pointer-events-none" />
              </td>
            </tr>
          </table>
        </div>

      </vx-card> -->
    </div>
  </div>
</template>

<script>
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'
import vSelect from 'vue-select'
import { performFetch } from '../../helpers'

export default {
  components: {
    vSelect
  },
  data () {
    return {
      user_data: null,
      user_not_found: false,
      userToMigrate: {},
      usersList: [],
      showBlankContent: false,
      showMigrateRecordsModal: false
    }
  },
  watch: {
    async showMigrateRecordsModal (value) {
      if (value) {
        this.$vs.loading({type: 'default'})
        await this.getUsersList()
        this.$vs.loading.close()
      }
    }
  },
  computed: {
    userAddress () {
      let str = ''
      for (const field in this.user_data.location) {
        str += `${field  } `
      }
      return str
    }
  },
  methods: {
    migrateRecords () {
      this.showMigrateRecordsModal = false
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('USER.confirmDeletionTitle'),
        text: `${this.$t('USER.confirmDelete')} "${this.user_data.email}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    async getUsersList () {
      return new Promise(async (resolve, reject) => {
        // await fetch(this.$store.state.auth.api_url, {
        //   method: 'POST', headers: {"Content-Type": "application/json"},
        //   body: JSON.stringify({
        //     command: 'get_application_users',
        //     parameters: {
        //       application_token: this.$store.state.auth.app_token,
        //       session_token: this.$store.state.auth.token
        //     }
        //   })
        // })
        await performFetch(this.$store.state.auth.api_url, {
          command: 'get_application_users',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token
          }
        })
          .then(async response => {
            if (response.status === 200) {
              await response.json().then(result => {
                const usersList = []
                const users = result.users

                users.forEach(user => {

                  if (user.hash !== this.user_data.hash) {
                    const userObject = {
                      hash: user.hash,
                      name: user.name
                    }

                    usersList.push(userObject)
                  }
                })

                this.usersList.sort((a, b) => {
                  if (a.name > b.name) {
                    return 1
                  }

                  if (a.name < b.name) {
                    return -1
                  }

                  return 0
                })

                this.usersList = usersList

                this.userToMigrate = this.usersList[0]

                resolve(true)
              })
            }
          })
          .catch(e => console.log(e))
      })
    },
    onSelectClick () {

      if (!this.showBlankContent) {

        try {
          const offsetHeight = document.querySelector('.vs__dropdown-menu').offsetHeight

          document.querySelector('#blank_content').style.height = `${offsetHeight  }px`

          this.showBlankContent = true
        } catch (e) {
          //
        }
      }
    },
    confirmDeleteRecord () {

      this.$vs.dialog({
        color: 'warning',
        title: this.$t('USER.attention'),
        text: this.$t('USER.migrateRecords'),
        accept: this.acceptMigrateUser,
        acceptText: 'Ok',
        buttonCancel: true,
        cancel: this.cancelMigrateUser
      })

      // this.$vs.dialog({
      //   type: 'confirm',
      //   color: 'danger',
      //   title: 'Confirm Delete',
      //   text: `You are about to delete "${this.user_data.username}"`,
      //   accept: this.deleteRecord,
      //   acceptText: 'Delete'
      // })
    },
    acceptMigrateUser () {
      this.showMigrateRecordsModal = true
    },
    cancelMigrateUser () {},
    deleteRecord () {
      /* Below two lines are just for demo purpose */

      this.$vs.loading({
        type: 'default'
      })

      fetch(this.$store.state.auth.api_url, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          command: 'delete_application_user',
          parameters: {
            application_token: this.$store.state.auth.app_token,
            session_token: this.$store.state.auth.token,
            user_hash: this.$route.params.userHash,
            user_to_migrate_hash: this.userToMigrate.hash
          }
        })
      })
        .then(async (response) => {
          if (response.status === 200) {
            await response.json().then(async (response) => {
              this.$vs.loading.close()
              this.$router.push({name:'users'})
              this.showDeleteSuccess()
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
            this.$vs.notify({
              title: this.$t('USER.operationNotPerformed'),
              text: this.$t('USER.deleteError'),
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
            this.$router.push({name:'users'})
          }
        })
        .catch((error) => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: this.$t('USER.operationNotPerformed'),
            text: this.$t('USER.deleteError'),
            iconPack: 'feather',
            icon: 'icon-icon-alert-circle',
            color: 'danger'
          })
          this.$router.push({name:'users'})
        })

      /* UnComment below lines for enabling true flow if deleting user */
      // this.$store.dispatch("userManagement/removeRecord", this.user_data.id)
      //   .then(()   => { this.$router.push({name:'app-user-list'}); this.showDeleteSuccess() })
      //   .catch(err => { console.error(err)       })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: this.$t('USER.userDeleted'),
        text: this.$t('USER.deleteSuccess')
      })
    }
  },
  created () {
    // Register Module UserManagement Module
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }

    const userHash = this.$route.params.userHash
    this.$store.dispatch('userManagement/fetchUser', userHash)
      .then(res => {
        this.user_data = res
        const user_languages = []
        this.user_data.languages.forEach(item => {
          user_languages.push(item.name)
        })
        this.user_data.languages = user_languages
        this.user_data.contacts = []

        if (this.user_data.contact_by_email) {
          this.user_data.contacts.push('Email')
        }

        if (this.user_data.contact_by_phone) {
          this.user_data.contacts.push('Phone')
        }

        if (this.user_data.contact_by_message) {
          this.user_data.contacts.push('Message')
        }
      })
      .catch(err => {
        if (err) {
          this.user_not_found = true

        }
      })
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

</style>
